module.exports = __webpack_public_path__ + "4f9874889ad84953e3ded0b684d4d93f.pdf";